import { atom } from "jotai";

export const activeWindowHistoryAtom = atom<string[]>([]);
